module.exports = __webpack_public_path__ + "static/media/PÖ-fi-background-Edge.df37a74d.jpg";